import { Navigate } from 'react-router-dom';
import { useCan } from './useCan';
import { adminNav, canSee } from './adminNav';
import { OwnerToday } from './dashboard/OwnerToday';
import { MyDay } from './myday/MyDay';
import { ADMIN_BASE } from '../utils/hosts';

/**
 * Vandaag — het eerste scherm. Wie de hele salon ziet krijgt de werklijst, dag en cijfers; een
 * collega haar dag (Mijn dag: de volgende klant bovenaan), zonder dagtotalen of omzet. Wie geen
 * agenda heeft (Marketing) gaat meteen naar het eerste onderdeel dat ze wel mag.
 */
export function Dashboard() {
  const {
    access,
    can,
    canAll
  } = useCan();
  if (canAll('agenda.view')) return <OwnerToday data-id="element-1542" data-mp="1k7fr7vnqa4y0" />;
  if (can('agenda.view')) return <MyDay data-id="element-1543" data-mp="1kaldz48vwuqk" />;
  const first = adminNav.find(n => n.key !== 'overzicht' && !n.hidden && !n.comingSoon && canSee(n, access));
  return <Navigate to={first?.to ?? `${ADMIN_BASE}/beveiliging`} replace data-id="element-1544" data-mp="2vnxgnbswr7b5" />;
}